import { render, staticRenderFns } from "./ItineraryDriverSettings.vue?vue&type=template&id=18de34de&scoped=true&"
import script from "./ItineraryDriverSettings.vue?vue&type=script&setup=true&lang=js&"
export * from "./ItineraryDriverSettings.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ItineraryDriverSettings.vue?vue&type=style&index=0&id=18de34de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de34de",
  null
  
)

export default component.exports